// user/src/features/lottery/AgentCardHistory.jsx
import { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore";

export default function AgentCardHistory({ user }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!user?.uid) return;
    const qy = query(
      collection(db, "cards"),
      where("agentUid", "==", user.uid),
      where("status", "==", "drawn"),
      orderBy("drawnAt", "desc")
    );
    return onSnapshot(qy, (snap) => {
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setRows(arr);
    });
  }, [user?.uid]);

  return (
    <div className="max-w-4xl mx-auto mt-8 md:mt-16">
      <h1 className="text-2xl font-bold mb-4">Card History</h1>
      <div className="space-y-3">
        {rows.map((c) => (
          <div
            key={c.id}
            className="p-4 rounded-2xl bg-slate-800 flex items-center justify-between"
          >
            <div>
              <div className="font-semibold">Card #{c.id.slice(0, 8)}…</div>
              <div className="text-sm text-slate-300">
                Drawn: {c.drawnAt?.toDate?.()?.toLocaleString?.() || "-"} ·
                Winning:{" "}
                <span className="rounded px-2 py-0.5 bg-yellow-300 text-black font-bold ml-1">
                  {String(c.winningNumber).padStart(2, "0")}
                </span>
              </div>
            </div>
            <div className="text-sm text-slate-300">
              Sold: <b>{c.filled?.length || 0}/100</b>
              <br />
              Winners: <b>{c.winners?.length || 0}</b>
            </div>
          </div>
        ))}
        {!rows.length && <div className="text-slate-400">No history yet.</div>}
      </div>
    </div>
  );
}
